/**
 * =============================================================================
 * APP COMPONENT - ROOT REDIRECT
 * =============================================================================
 * 
 * Root application component that handles the default route.
 * Redirects users from the root path (/) to the Widget demo page (/widget).
 * 
 * This ensures that visitors landing on the base URL are automatically
 * directed to the main demo page rather than seeing an empty page.
 * 
 * Route Structure:
 * - /           → Redirects to /widget (this component)
 * - /widget     → Widget demo page (WidgetDemo.js)
 * - /map        → Map demo page (MapDemo.js)
 * - /terms      → Terms of service page
 * - /admin      → Analytics dashboard
 * - /admin/embed → Admin embed management
 * 
 * =============================================================================
 */

import React from 'react';
import { Navigate } from 'react-router-dom';

// =============================================================================
// MAIN COMPONENT
// =============================================================================

/**
 * App Component
 * 
 * Simple redirect component that sends users from the root URL
 * to the widget demo page. Uses React Router's Navigate component
 * with 'replace' to prevent the redirect from being added to history.
 * 
 * @returns {JSX.Element} Navigate component that redirects to /widget
 */
function App() {
  return <Navigate to="/widget" replace />;
}

export default App;